export const LOGIN = "login";
export const LOGOUT = "logout";
export const CHECK_AUTH = "checkAuth";
export const FETCH_USER = "fetchProfile";
export const RESET_PASSWORD = "resetPassword";

export const FETCH_EMPLOYEE = "fetchEmployee";
export const FETCH_EMPLOYEES = "fetchEmployees";
export const EMPLOYEE_EDIT = "editEmployee";
export const EMPLOYEE_DELETE = "deleteEmployee";
export const EMPLOYEE_ADD = "addEmployee";

export const FETCH_DEPENDENT = "fetchDependent";
export const FETCH_DEPENDENTS = "fetchDependents";
export const FETCH_DEPENDENTS_BY_EMPLOYEE = "fetchDependentsByEmployee";
export const DEPENDENT_ADD = "addDependent";
export const DEPENDENT_EDIT = "editDependent";
export const DEPENDENT_DELETE = "deleteDependent";

export const FETCH_UNIT = "fetchUnit";
export const FETCH_UNITS = "fetchUnits";
export const FETCH_UNITS_DEPARTMENT = "fetchUnitsByDepartment";

export const FETCH_INSURANCE = "fetchInsurance";
export const VARIFIED_CARD = "cardVarified";

export const UPLOAD_IMAGE = "uploadImage";
export const UPLOAD_IMAGE_DEPENDENT = "uploadDependentImage";

export const FETCH_MANIFEST = "fetchManifest";
